import React from 'react';
const styles = {"auth-notice":"AuthNotice-module__auth-notice__JA-2K","title":"AuthNotice-module__title__qEH6l","message":"AuthNotice-module__message__OlZ5k","info":"AuthNotice-module__info__uBla-","warning":"AuthNotice-module__warning__h-yKx","error":"AuthNotice-module__error__-YcRu"};
export function AuthNotice({ variant, title, message, children }) {
    return (React.createElement("div", { role: "alert", className: `${styles['auth-notice']} ${styles[variant]}` },
        React.createElement("p", { className: styles.title }, title),
        React.createElement("p", { className: styles.message }, message),
        children));
}
//# sourceMappingURL=AuthNotice.js.map